
import { createContext } from "react";

export interface ILoadingContext {
    loading: boolean;
    validating: boolean;
}

export const LoadingContext = createContext<ILoadingContext>({
    loading: false,
    validating: false
})